"use strict";

var HBTickets = function () {
    var _ticketMessage;
    var _initMessageRating = function () {
        var _ticketSection = $('.section-ticket'),
            _ratingScale = _ticketSection.data('rating-scale');

        _ticketSection.find(".rating-box input").rating(_ratingScale);
    }

    var _initTicketRating = function () {
        var _ticketRateSection = $('.section-ticket-rate'),
            _rateError = _ticketRateSection.data('rate-error'),
            _rateScale = _ticketRateSection.data('rating-scale'),
            _rateRate = _ticketRateSection.data('rate'),
            input = _ticketRateSection.find(".rating-box input"),
            _rateInput = $('#ticket_rate'),
            emote = $('.rating .rating-icon'),
            _rateTicketBtn = $('.rate_ticket_btn');

        input.max = _rateScale;
        input.rating(false);

        emote.off().on('click', function () {
            var self = $(this);
            _rateInput.val(self.data('value'));
            if (_rateScale == 3) {
                emote.each(function () {
                    $(this).css('opacity', '0.4');
                });
                self.css('opacity', '1');
            }
        });
        _rateTicketBtn.on('click', function () {
            if (!_rateInput.val()) {
                HBNotify.notifyError(_rateError);
                return false;
            }
        });

        if (_rateScale != 3) {
            $('.rating-input').on('click', function () {
                var _self = $(this),
                    _val = _self.attr('data-value');
                if (!_rateInput.val()) {
                    _rateInput.val(_val);
                    $(this).parent().find('input').val(_val).end().off('mousemove mouseleave click');
                    return false;
                }
            });
        }

        if (_rateRate) {
            $(function () {
                $('.rating-input').find("[data-value='" + _rateRate + "']").mousemove().click();
                $('.rating').find("[data-value='" + _rateRate + "']").click();
            });
        }
        input.rating(_rateScale);
    }

    var showdropzone = function (e) {
        var dropZone = $('#dropzone').not('.hidden');
        dropZone.show();
        setTimeout(function () {
            hidedropzone()
        }, 6000);
    }

    var hidedropzone = function () {
        $('#dropzone').hide().addClass('hidden');
    }

    var _initFileUpload = function () {
        $('#fileupload').each(function () {
            var self = $(this);
            self.fileupload({
                dataType: 'json',
                autoUpload: true,
                url: self.data('url'),
                formData: [{name: '_v', value: 2}]
            }).bind('fileuploadsend', function () {
                $('.table-files').parent().show();
                $('.fileupload-progress').show();
            }).bind('fileuploadalways', function () {
                $('.fileupload-progress').hide();
            }).bind('fileuploaddragover', showdropzone)
                .bind('fileuploaddrop', hidedropzone);
        });
    }

    return {
        // public functions
        init: function () {
            _initMessageRating();
            _initTicketRating();
            _initFileUpload();

            _ticketMessage = $('#ticketmessage');

            if (!_ticketMessage.length) {
                $('.quoter').hide();
            }
        },
        quoteTicket: function (target) {
            var resp = $('#' + target).html();
            var reply = _ticketMessage.val();
            _ticketMessage.val(reply + "\r\n>" + resp.replace(/\n/g, "\n>") + "\r\n").change().focus();
            return false;
        },
        switchdeptdesc: function (items) {
            $('.deptsdesc').children().hide();
            $('.dept_' + items).show();
            $('.dptpriority').hide().find('select').attr('disabled', 'disabled');
            $('#p' + items).show().find('select').removeAttr('disabled');
        }
    };
}();

jQuery(document).ready(function () {
    HBTickets.init();
});

